import { injectReducer } from '@modules/reducers'
import { injectSagas } from '@modules/sagas'

// Sync route definition
export default (store: Store): RouteConfig => ({
  path: '/users-hierarchy',
  layout: true,
  getComponent: async () => {
    const UsersHierarchyLayout = await import(
      /* webpackChunkName: "users-hierarchy-modules" */ './components/UsersHierarchyLayout'
    )
    const { reducer, rootSagas, } = await import(
      /* webpackChunkName: "users-hierarchy-modules" */ './UsersHierarchyModule'
    )

    injectReducer(store, { key: 'users-hierarchy', reducer, })
    injectSagas(store, rootSagas)

    return {
      children: UsersHierarchyLayout.default,
    }
  },
  childRoutes: [
    {
      path: '/',
      title: 'users-hierarchy.list_title', // Here you can use a plain string o a transalation key
      getComponent: async () => {
        const UsersHierarchyView = await import(
          /* webpackChunkName: "users-hierarchy-modules" */ './components/UsersHierarchyView'
        )
        return {
          children: UsersHierarchyView.default,
        }
      },
    },
  ],
})

